import { Button, FloatButton, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getShowInstructionHint } from "../../redux/selectors";
import QuestionMarkIcon from "remixicon-react/QuestionMarkIcon";
import { iconSizeBigger } from "../../config";
import InstructionHint from "../InstructionHint/InstructionHint";
import { setAutoHint } from "../../redux/ui/ui";

function ShowHints() {
  const dispatch = useDispatch();
  return (
    <Button type="text" onClick={() => dispatch(setAutoHint(true))}>
      Show hints
    </Button>
  );
}

export function HelpButton({ style }) {
  const showInstructions = useSelector(getShowInstructionHint);
  return showInstructions ? (
    <InstructionHint style={style} />
  ) : (
    <Popover content={<ShowHints />} trigger="click" arrow={false}>
      <FloatButton
        style={style}
        icon={<QuestionMarkIcon size={iconSizeBigger} />}
      ></FloatButton>
    </Popover>
  );
}
